<div class="container" (click)="clicked()">
    <fa-icon class="icon" icon="copy"></fa-icon>
    <div class="tooltip"  [style.opacity]="showTooltip ? 1 : 0">
        <span class="text">Kopieret</span>
    </div>
</div>